module.exports = __webpack_public_path__ + "static/media/share-alt-square.1f769e8c.svg";